module.exports = __webpack_public_path__ + "static/media/Kissen_60x40_rueckseite.2800c700.png";